import { heritageCatalogSyncMessage } from "./heritageCatalogSyncMessage";

type Props = {
  vendorName?: string | null;
  branchName?: string | null;
  branchCode?: string | null;
  companyDisplayName?: string | null;
  syncKind?: "branch" | "purchase_history" | null;
  className?: string;
};

const HeritageCatalogSyncBanner = ({
  vendorName,
  branchName,
  branchCode,
  companyDisplayName,
  syncKind = "branch",
  className = "text-sm text-amber-900 bg-amber-50 border border-amber-200 rounded-md p-3 flex items-start gap-2",
}: Props) => (
  <div role="status" aria-live="polite" className={className}>
    <span className="mt-1.5 h-2 w-2 flex-shrink-0 rounded-full bg-amber-500 animate-pulse" aria-hidden />
    <span>
      {heritageCatalogSyncMessage({
        vendorName,
        branchName,
        branchCode,
        companyDisplayName,
        syncKind,
      })}
    </span>
  </div>
);

export default HeritageCatalogSyncBanner;
